import { Injectable } from '@angular/core';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { ErrorFormCommissioningEnum } from '@bo-client/activation-management/shared/forms/create-forms-errors-model';
import { FormGroup } from '@angular/forms';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';

@Injectable({
  providedIn: 'root'
})
export class CommissioningFormsErrorsService {
  constructor() {}

  checkIfErrorExist(errorText: any, errorList: ShowErrorModel[]): boolean {
    let errorExist = false;
    if (errorList && errorList.length > 0) {
      const idx = errorList.findIndex((ele) => ele.controlName == errorText);
      if (idx != -1) {
        errorExist = true;
      }
    }
    return errorExist;
  }

  updateErrorListAccordingCondition(hasError: boolean, fieldName: string, errorList: ShowErrorModel[]) {
    if (!errorList) {
      errorList = new Array<ShowErrorModel>();
    }
    const idxError = errorList.findIndex((ele) => ele.controlName == fieldName);
    if (hasError) {
      if (idxError == -1) {
        errorList.push(
          ErrorFormCommissioningEnum[
            ErrorFormCommissioningEnum.findIndex((ele) => ele.controlName == fieldName)
          ]
        );
      }
    } else {
      if (idxError != -1) {
        errorList.splice(idxError, 1);
      }
    }
    return errorList;
  }
}
